module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/common/browsers-05b1deea6ea3b471a751ae11d21cfc8a.svg";